import { render } from "./InsurerLayout.vue?vue&type=template&id=e5b87c9c"
import script from "./InsurerLayout.vue?vue&type=script&lang=js"
export * from "./InsurerLayout.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./InsurerLayout.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_09d06e80%2Fpackages%2Finsurer%2Fsrc%2Flayouts%2FInsurerLayout.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__